import {
  listallUsersinproject,
  ListallUsersinprojectResponse,
  ListallUsersinprojectData,
  withoutNullProjectUsers,
} from '@data-access/connect/tc-tcps';
import type { Client } from '@data-access/connect/tc-issue-management';
import { useQuery, UseQueryResult, QueryClient } from '@tanstack/solid-query';
import { Accessor } from 'solid-js';

export class TcpsProjectApiService {
  constructor(
    private readonly client: Client,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore TS6138: Reserved for future use
    private readonly queryClient: QueryClient
  ) {}

  // Query for listing all users in a project
  public getProjectUsersQuery(
    options: Accessor<Omit<ListallUsersinprojectData, 'client'>>
  ): UseQueryResult<ListallUsersinprojectResponse, Error> {
    return useQuery(() => ({
      queryKey: ['project-users', options()],
      queryFn: async (): Promise<ListallUsersinprojectResponse> => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const response = await listallUsersinproject({
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          client: this.client as any,
          ...options(),
        });

        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (response.error) {
          throw new Error('Failed to list project users');
        }

        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
        return withoutNullProjectUsers(response.data);
      },
      enabled: !!options().path.projectId,
    }));
  }
}
